import AirDatepicker from "air-datepicker";
import localeRu from "air-datepicker/locale/ru";
import localeEn from "air-datepicker/locale/en";
import focusManager from "focus-manager";
import {loadCaptchaToken} from "@main/helpers/is-valid-field";
import {ToggleScroll} from "@main/components/toggle-scroll";

/** Класс модального окна с заявкой на работу. */
class QuestionnaireModal {    
    documentEl = document.body

    calendar
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.modal = this.documentEl.querySelector(".js-modal-questionnaire");
        this.datepicker = this.modal.querySelector(".js-datepicker");
        this.minDate = this.datepicker.getAttribute("data-min-date");
        this.maxDate = this.datepicker.getAttribute("data-max-date");
        this.locale = this.datepicker.getAttribute("data-locale");
        this.openModalButton = this.el.querySelector(".js-open-modal-questionnaire");
        loadCaptchaToken(this.el, "input[name='captcha_token']");
        this.createCalendar();
        this.listenEvents();
    }

    /**
     * Прослушиваем событие клика на кнопку заявки.
     * 
     * @returns {void}
     */
    listenEvents() {
        this.openModalButton.addEventListener("click", () => {
            this.modal.classList.add("shown");
            ToggleScroll.disable(this.modal);
            focusManager.capture(this.modal);
        });
    }

    /**
     * Создание календаря.
     * 
     * @returns {void}
     */
    createCalendar() {
        new AirDatepicker(this.datepicker, {
            inline: false,
            position: "bottom right",
            locale: this.locale === "ru" ? localeRu : localeEn,
            dateFormat: "dd.MM.yyyy",
            multipleDates: false,
            autoClose: true,
            showEvent: "click",
            prevHtml: 
            `<svg width="20" height="20">
                <use href="#calendar-arrow-prev"></use>
            </svg>`,
            nextHtml: 
            `<svg width="20" height="20">
                <use href="#calendar-arrow-next"></use>
            </svg>`,
            minDate: this.minDate,
            maxDate: this.maxDate,
            visible: false,
        });
    } 
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-work-questionnaire").forEach((item) => new QuestionnaireModal(item));
});
